// src/components/AddEspecieModal.js

import React, { useState, useEffect } from 'react';
import Modal from './common/Modal';
import { fieldStyles } from '../config/formStyles';

const AddEspecieModal = ({ isOpen, onClose, onSaveEspecie, especies }) => {
    const [ticker, setTicker] = useState('');
    const [moneda, setMoneda] = useState('Pesos');
    const [error, setError] = useState('');

    useEffect(() => {
        if (isOpen) {
            setTicker('');
            setMoneda('Pesos');
            setError('');
        }
    }, [isOpen]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!ticker.trim()) {
            setError('El ticker de la especie no puede estar vacío.');
            return;
        }
        const tickerUpper = ticker.trim().toUpperCase();
        const especieExistente = especies.find(esp => esp.id.toUpperCase() === tickerUpper);

        if (especieExistente) {
            const userConfirmation = window.confirm(
                `La especie "${tickerUpper}" ya existe con la moneda "${especieExistente.moneda}".\n\n¿Desea sobreescribirla con la nueva moneda "${moneda}"?`
            );
            if (userConfirmation) {
                onSaveEspecie(tickerUpper, moneda);
                onClose();
            }
        } else {
            onSaveEspecie(tickerUpper, moneda);
            onClose();
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            title="Agregar/Editar Especie"
            maxWidth="500px"
            zIndex={2001}
            onSubmit={handleSubmit}
            error={error}
            footer={<>
                <button type="button" onClick={onClose} style={{ ...fieldStyles.button, ...fieldStyles.secondaryButton }}>Cancelar</button>
                <button type="submit" style={fieldStyles.button}>Guardar Especie</button>
            </>}
        >
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
                <div>
                    <label style={fieldStyles.label}>Ticker de Especie (Ej: AL30, GD30)</label>
                    <input
                        type="text"
                        value={ticker}
                        onChange={(e) => setTicker(e.target.value)}
                        style={fieldStyles.input}
                        autoFocus
                        required
                    />
                </div>
                <div>
                    <label style={fieldStyles.label}>Moneda de la Especie</label>
                    <select
                        value={moneda}
                        onChange={(e) => setMoneda(e.target.value)}
                        style={fieldStyles.select}
                    >
                        <option value="Pesos">Pesos</option>
                        <option value="USD Mep">USD Mep</option>
                        <option value="USD CCL">USD CCL</option>
                    </select>
                </div>
            </div>
        </Modal>
    );
};

export default AddEspecieModal;
